import React from 'react';
import { Link } from 'react-router-dom';
import { Wordmark } from '../components';

export const About = () => {
  return (
    <div style={{ minHeight: '100vh', background: 'var(--bg)', color: 'var(--ink)' }}>
      {/* Nav */}
      <header style={{
        position: 'sticky', top: 0, zIndex: 100,
        borderBottom: '1px solid var(--line)',
        background: 'oklch(1 0 0 / 0.85)',
        backdropFilter: 'blur(12px)',
        padding: '0 24px',
      }}>
        <div style={{ maxWidth: 900, margin: '0 auto', height: 60, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Link to="/" style={{ textDecoration: 'none' }}>
            <Wordmark size={22} />
          </Link>
          <Link to="/"
            style={{ fontSize: 13, color: 'var(--ink-2)', textDecoration: 'none', fontFamily: 'var(--font-mono)', letterSpacing: '.06em' }}>
            ← Back to home
          </Link>
        </div>
      </header>

      {/* Hero */}
      <section style={{ padding: '80px 24px 60px', textAlign: 'center', borderBottom: '1px solid var(--line)' }}>
        <div style={{ maxWidth: 720, margin: '0 auto' }}>
          <div style={{ marginBottom: 24 }}>
            <img 
              src="/ventyvip-logo.png" 
              alt="VentyVIP Logo"
              style={{
                width: 'clamp(60px, 8vw, 80px)',
                height: 'auto',
                filter: 'drop-shadow(0 4px 12px rgba(0,0,0,0.1))'
              }}
            />
          </div>
          <div style={{ fontFamily: 'var(--font-mono)', fontSize: 11, letterSpacing: '.14em', textTransform: 'uppercase', color: 'var(--ink-3)', marginBottom: 16 }}>
            About VentyVIP
          </div>
          <h1 style={{ fontSize: 'clamp(36px, 5vw, 64px)', lineHeight: 1.05, letterSpacing: '-0.02em', marginBottom: 24 }}>
            We built the briefing tool<br /> we always wished existed.
          </h1>
          <p style={{ fontSize: 18, color: 'var(--ink-2)', lineHeight: 1.7, maxWidth: 580, margin: '0 auto' }}>
            VentyVIP started as a simple idea: going to an event shouldn't feel like a research project.
            We do the homework so you can just show up — confident, prepared, and ready to have a great time.
          </p>
        </div>
      </section>

      {/* Story */}
      <section style={{ padding: '72px 24px', borderBottom: '1px solid var(--line)' }}>
        <div style={{ maxWidth: 720, margin: '0 auto', display: 'grid', gap: 48 }}>
          <div>
            <div style={{ fontFamily: 'var(--font-mono)', fontSize: 11, letterSpacing: '.14em', textTransform: 'uppercase', color: 'var(--primary-strong)', marginBottom: 12 }}>
              Our Story
            </div>
            <h2 style={{ fontSize: 'clamp(24px, 3vw, 36px)', marginBottom: 16 }}>Built For Every Event Type, Every Event Attendee!</h2>
            <p style={{ fontSize: 16, color: 'var(--ink-2)', lineHeight: 1.75 }}>
              Whether it's your first 5K, a solo trip to a music festival, or a networking event in a new city —
              showing up without context is stressful. VentyVIP pulls the intel that actually matters:
              what to wear, where to park, what the weather will be, and who to call if something goes wrong.
              All from a single URL.
            </p>
            <p style={{ fontSize: 16, color: 'var(--ink-2)', lineHeight: 1.75, marginTop: 16 }}>
              We want you to feel like an event VIP, a VentyVIP!
            </p>
          </div>

          <div>
            <div style={{ fontFamily: 'var(--font-mono)', fontSize: 11, letterSpacing: '.14em', textTransform: 'uppercase', color: 'var(--primary-strong)', marginBottom: 12 }}>
              How It Works
            </div>
            <h2 style={{ fontSize: 'clamp(24px, 3vw, 36px)', marginBottom: 16 }}>Paste a URL. Get a brief.</h2>
            <p style={{ fontSize: 16, color: 'var(--ink-2)', lineHeight: 1.75 }}>
              Our AI reads the event page and extracts the details most attendees want to know —
              formatted into a clean, printable brief you can download as a PDF or share with friends.
              No account needed. Always free to use.
            </p>
          </div>

          <div>
            <div style={{ fontFamily: 'var(--font-mono)', fontSize: 11, letterSpacing: '.14em', textTransform: 'uppercase', color: 'var(--primary-strong)', marginBottom: 12 }}>
              For Organizers
            </div>
            <h2 style={{ fontSize: 'clamp(24px, 3vw, 36px)', marginBottom: 16 }}>Get your event in front of the right people</h2>
            <p style={{ fontSize: 16, color: 'var(--ink-2)', lineHeight: 1.75 }}>
              Our Spotlight section is seen by thousands of VIPs every week.
              If you're an organizer looking to reach engaged, curious attendees, we'd love to feature your event.
            </p>
            <a
              href="/organizers"
              style={{ display: 'inline-block', marginTop: 16, fontSize: 14, color: 'var(--primary-strong)', fontWeight: 600, textDecoration: 'none' }}>
              Learn about featuring your event →
            </a>
          </div>
        </div>
      </section>

      {/* Values */}
      <section style={{ padding: '72px 24px', borderBottom: '1px solid var(--line)', background: 'oklch(0.98 0.01 210 / 0.4)' }}>
        <div style={{ maxWidth: 720, margin: '0 auto' }}>
          <div style={{ fontFamily: 'var(--font-mono)', fontSize: 11, letterSpacing: '.14em', textTransform: 'uppercase', color: 'var(--ink-3)', marginBottom: 32, textAlign: 'center' }}>
            What we believe
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 32 }}>
            {[
              { icon: '🆓', title: 'Free, always', body: 'Generating a brief will never cost you anything. No hidden tiers.' },
              { icon: '🔒', title: 'No account needed', body: 'Paste, generate, download. No sign-up required to get your brief.' },
              { icon: '🎯', title: 'Only what matters', body: 'We cut the fluff. Every brief field is there because attendees actually need it.' },
              { icon: '🤝', title: 'Organizer-friendly', body: 'We work with organizers, not against them. Spotlight is a partnership.' },
            ].map(v => (
              <div key={v.title} style={{ padding: '24px', background: 'var(--bg)', borderRadius: 'var(--radius)', border: '1px solid var(--line)' }}>
                <div style={{ fontSize: 28, marginBottom: 10 }}>{v.icon}</div>
                <div style={{ fontWeight: 600, fontSize: 15, marginBottom: 8 }}>{v.title}</div>
                <div style={{ fontSize: 14, color: 'var(--ink-2)', lineHeight: 1.6 }}>{v.body}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section style={{ padding: '72px 24px' }}>
        <div style={{ maxWidth: 860, margin: '0 auto', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: 24 }}>
          <div style={{ textAlign: 'center', padding: '40px 32px', borderRadius: 'var(--radius-lg)', border: '1px solid var(--line)', background: 'var(--bg)' }}>
            <div style={{ fontSize: 32, marginBottom: 12 }}>🎟️</div>
            <h2 style={{ fontSize: 'clamp(20px, 2.5vw, 28px)', marginBottom: 12 }}>Ready to show up prepared?</h2>
            <p style={{ fontSize: 15, color: 'var(--ink-2)', marginBottom: 28, lineHeight: 1.6 }}>Paste any event URL and get your free brief in seconds.</p>
            <a
              href="/"
              className="btn btn-primary">
              Try VentyVIP free →
            </a>
          </div>
          <div style={{ textAlign: 'center', padding: '40px 32px', borderRadius: 'var(--radius-lg)', border: '1px solid var(--primary-soft)', background: 'var(--primary-tint)' }}>
            <div style={{ fontSize: 32, marginBottom: 12 }}>📣</div>
            <h2 style={{ fontSize: 'clamp(20px, 2.5vw, 28px)', marginBottom: 12 }}>Are you an event organizer?</h2>
            <p style={{ fontSize: 15, color: 'var(--ink-2)', marginBottom: 28, lineHeight: 1.6 }}>Get your event featured in our Spotlight — seen by thousands of VIPs every week.</p>
            <a
              href="/organizers"
              className="btn btn-primary">
              Contact us to get featured →
            </a>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer style={{ borderTop: '1px solid var(--line)', padding: '24px', textAlign: 'center', fontSize: 12, color: 'var(--ink-4)', fontFamily: 'var(--font-mono)' }}>
        © 2026 VentyVIP
      </footer>
    </div>
  );
};
